<mat-form-field appearance="outline" class="w-full">
  <mat-label>{{ label() }}</mat-label>
  <!-- Bound to the form's control: the value, disabled, touched and the error state all come from it. -->
  <mat-select
    [class]="'pl-3' + (search().length > 0 ? ' pr-3' : '') "
    [formControl]="control"
    (selectionChange)="onSelectionChanged($event.value)"
    (openedChange)="onOpenedChange($event, searchInput)">
    <!-- The search box, pinned above the list. It is not an option, so it cannot be chosen or reached with the arrow keys; typing in it
         must not move through the list or close it. -->
    <div class="sticky top-[-10px] z-1 bg-white">
      <mat-form-field class="w-full" subscriptSizing="dynamic">
      <input
        #searchInput
        matInput
        class=" w-full py-2 px-4"
        [placeholder]="searchPlaceholder()"
        [value]="search()"
        (input)="onSearchChanged(searchInput.value)"
        (keydown)="$event.stopPropagation()" />
        <mat-icon matPrefix>search</mat-icon>
        @if(search().length > 0){
        <button
              matIconButton
              matSuffix
              type="button"
              (click)="onSearchChanged('')"
              [disabled]="loading()"
              [attr.aria-label]="'Search/Filter'"
              matTooltip="Clear"
            >
              <mat-icon>close</mat-icon>
        </button>
        }
      </mat-form-field>
    </div>
    <mat-option value="">{{ placeholder() }}</mat-option>
    @for (item of visibleOptions(); track item.id) {
      <mat-option [value]="item.id">{{ optionLabel(item) }}</mat-option>
    } @empty {
      @if (!loading()) {
        <mat-option disabled>No results</mat-option>
      }
    }
    @if (loading()) {
      <mat-option disabled>{{ loadingLabel() }}</mat-option>
    }
  </mat-select>
  @if (hasRequiredError()) {
    <mat-error>{{ requiredError() }}</mat-error>
  }
</mat-form-field>
